<template>
  <div class="goods-list">
    <div class="goods-item" v-for="item in [1,2,3,4,5,6,7,8]" :key="item">
      <div class="goods-image">
        <img src="../assets/goods1.png" alt="">
      </div>
      <div class="goods-name">
        Short sleeve breathable
      </div>
      <div class="goods-info">
        <div>Composition:P/SP 92/8</div>
        <div>Weight:350GSM</div>
        <div>Style No:211F063</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Navigation',
  created () {
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped>
.goods-list {
  margin-top: 20px;
}
.goods-item {
  width: 252px;
  display: inline-block;
  margin-left: 3px;
  margin-right: 3px;
  margin-bottom: 10px;
}
.goods-image {
  width: 100%;
}
.goods-image img {
  width: 100%;
  height: 250px;
}
.goods-name {
  font-size: 16px;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/GoodsList.vue